var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHoverInfoIcon = function SvgHoverInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "info-f",
    d: "M10 20a10 10 0 1 1 10-10 10 10 0 0 1-10 10Zm0-12a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1Zm0-1a1 1 0 1 0-1-1 1 1 0 0 0 1 1Z",
    fill: "#d8d8d8"
  })));
};
export { SvgHoverInfoIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaW5mby1mIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgPHBhdGggaWQ9ImluZm8tZi0yIiBkYXRhLW5hbWU9ImluZm8tZiIgZD0iTTEwLDIwQTEwLDEwLDAsMSwxLDIwLDEwLDEwLDEwLDAsMCwxLDEwLDIwWk0xMCw4QTEsMSwwLDAsMCw5LDl2NWExLDEsMCwwLDAsMiwwVjlBMSwxLDAsMCwwLDEwLDhabTAtMUExLDEsMCwxLDAsOSw2LDEsMSwwLDAsMCwxMCw3WiIgZmlsbD0iI2Q4ZDhkOCIvPg0KPC9zdmc+DQo=";